import { render, staticRenderFns } from "./MobileCartWidget.vue?vue&type=template&id=3b46d9cb&"
import script from "./MobileCartWidget.vue?vue&type=script&lang=ts&"
export * from "./MobileCartWidget.vue?vue&type=script&lang=ts&"
import style0 from "./MobileCartWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports